var map = {
	"./AcmeElevators.png": "2eb6",
	"./de-licence-plate-removebg-preview.png": "defb",
	"./gas-safe-logo.png": "b8cb",
	"./gb-licence-plate.png": "fa24",
	"./iso-logo-print.gif": "c311",
	"./logo.png": "4ffd",
	"./logo.webp": "8e99",
	"./malaysia-licence-plate.png": "89d9",
	"./oftec-logo.png": "326a",
	"./usa-licence-plate.png": "ac5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";